// Module-level home for the HelpHero instance, replacing the Vue 2
// `Vue.prototype.$hlp` bridge for non-component readers.
// Set by ExternalAnalytics.vue once HelpHero initializes; read by the store
// plugin (updateHelpHeroData). Components keep using `this.$hlp` via
// app.config.globalProperties.
import type { HelpHero } from 'helphero'

let hlp: HelpHero | null = null

export function setHelpHero(instance: HelpHero | null) {
  hlp = instance
}

export function getHelpHero(): HelpHero | null {
  return hlp
}
